// @owners { team: patient-health }
import { getSelectedVideo } from '~shared/features/instructional-videos/selectors/getSelectedVideo';
import getIsModalShowing from '~shared/selectors/modal/getIsModalShowing';
import getModalType from '~shared/selectors/modal/getModalType';
import { connect } from '~shared/store';
import { type ReduxStateShared } from '~shared/types';
import MedListVideoPrepInfoModal from './MedListVideoPrepInfoModal';

const mapStateToProps = (state: ReduxStateShared) => {
  return {
    video: getSelectedVideo(state),
    show: getIsModalShowing(state) && getModalType(state) === 'VIDEO_PREP_INFO_MODAL',
  };
};

export default connect(mapStateToProps)(MedListVideoPrepInfoModal);
